module.exports = __webpack_public_path__ + "media/images/lp_seiho/sec01_img_02-03a1602009ee16fddc27276967732d92.png";